/* --------------------------------------------------------------------------------------
   errorAlertBody.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { Text } from "preact-i18n";

const ErrorAlertBody = ({error}) => {
    return <div class="text-white xmx-2">
        <h2 class="xmb-3"><Text id={error.title}>{error.title}</Text></h2>
        {error.textKeys?.map(key => <p><Text id={key} /></p>)}
        {error.raw? <p>{error.raw}</p> : null}
    </div>
}

export default ErrorAlertBody;